<p-progressBar *ngIf="patientDataService.showProgressBar" mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>

<router-outlet></router-outlet>
